import React from 'react'
import { FormGroup } from 'reactstrap';
import { StyledTextInputContainer, StyledLabel } from './Inputs.styles';
import ReactTooltip from 'react-tooltip'
import TourTooltip from './TourTooltip';

/** Incluir/editar pretendente a partir do resumo (mobile e web). */
export const isResumePretendenteForm = () => {
  if (typeof window === 'undefined') return false;
  const p = window.location.pathname || '';
  return (
    /\/intranet\/operacional\/solicitacao\/resumo\/pretendente(\/|$)/.test(p) ||
    /\/intranet\/operacional\/solicitacao\/resumo\/adicionar-pretendente(\/|$)/.test(p)
  );
};

/** Mesma rota acima, só em viewport desktop (tooltips em quina etc.). */
export const isResumePretendenteFormDesktop = () =>
  isResumePretendenteForm() && typeof window !== 'undefined' && window.innerWidth > 800;

/** Editar imóvel / locação a partir do resumo (evita ? sobreposto ao label). */
export const isResumeLocacaoForm = () => {
  if (typeof window === 'undefined') return false;
  return /\/intranet\/operacional\/solicitacao\/resumo\/locacao(\/|$)/.test(
    window.location.pathname || ''
  );
};

const LOCACAO_TOOLTIP_LABELS = ['Cód. do imóvel', 'Aluguel', 'Tipo de imóvel'];
const LOCACAO_TOOLTIP_TARGETS = {
  'Cód. do imóvel': 'tooltip-input-cod-imovel',
  Aluguel: 'tooltip-input-aluguel',
  'Tipo de imóvel': 'tooltip-input-tipo-imovel',
};

const handleLabel = (label, htmlFor, type, labelStyleOverrides = {}) => {
  let marginBottom = '2px';
  let visibility = 'visible';

  if (label === 'WITHOUT_LABEL') {
    visibility = 'hidden';
  }

  if (type !== 'select') {
    marginBottom = '6px';
  }

  if (label === undefined) {
    return null;
  }

  return (
    <StyledLabel
      color="color_purple"
      style={{ visibility, marginBottom, ...labelStyleOverrides }}
      htmlFor={htmlFor}
    >
      {label}
    </StyledLabel>
  );
};

const renderTooltip = (label) => {
  const isPretendenteFormDesktop = isResumePretendenteFormDesktop();
  const cornerStyle = isPretendenteFormDesktop ? { top: -10, right: -10, zIndex: 4 } : null;
  /* TourTooltip default inclui right:15; com left fixo precisa limpar right para não sobrepor o label. */
  const withCorner = (fallbackStyle) => cornerStyle || fallbackStyle;

  if(label === 'Cód. do imóvel') {
    if (isResumeLocacaoForm()) {
      return (
        <ReactTooltip id="tooltip-input-cod-imovel" place="right" type="dark" effect="float">
          Endereço e código do imóvel são campos opcionais, e não interferem no cálculo do risco.
        </ReactTooltip>
      );
    }
    return(
      <React.Fragment>
        <TourTooltip
          target="tooltip-input-cod-imovel"
          style={withCorner({ top: -10, left: 82, right: 'auto', zIndex: 4 })}
        />
        <ReactTooltip id="tooltip-input-cod-imovel" place="right" type="dark" effect="float">
          Endereço e código do imóvel são campos opcionais, e não interferem no cálculo do risco.
        </ReactTooltip>
      </React.Fragment>
    )
  }

  if(label === 'Aluguel') {
    if (isResumeLocacaoForm()) {
      return (
        <ReactTooltip id="tooltip-input-aluguel" place="right" type="dark" effect="float">
          <span>É possível <b>editar</b> o endereço do <br />imóvel, valor do aluguel + encargos</span>
        </ReactTooltip>
      );
    }
    return(
      <React.Fragment>
        <TourTooltip
          target="tooltip-input-aluguel"
          style={withCorner({ top: -10, left: 42, right: 'auto', zIndex: 4 })}
        />
        <ReactTooltip id="tooltip-input-aluguel" place="right" type="dark" effect="float">
          Aluguel + encargos são informações essenciais para a geração do Risco da Locação
        </ReactTooltip>
      </React.Fragment>
    )
  }

  if(label === 'Tipo de imóvel') {
    if (isResumeLocacaoForm()) {
      return (
        <ReactTooltip id="tooltip-input-tipo-imovel" place="right" type="dark" effect="float">
          <span>Caso precise você pode <b>alterar</b> o tipo de imóvel.</span>
        </ReactTooltip>
      );
    }
    return(
      <React.Fragment>
        <TourTooltip
          target="tooltip-input-tipo-imovel"
          style={withCorner({ top: -10, left: 80, right: 'auto', zIndex: 4 })}
        />
        <ReactTooltip id="tooltip-input-tipo-imovel" place="right" type="dark" effect="float">
          <span>O tipo de imóvel também é muito importante <br /> para calcularmos o risco da locação.</span>
        </ReactTooltip>
      </React.Fragment>
    )
  }

  // if(label === 'Pretendente a') {
  //   return(
  //     <React.Fragment>
  //       <TourTooltip
  //         target="tooltip-input-tipo-pretendente"
  //         style={{right: -10}}
  //       />
  //       <ReactTooltip id="tooltip-input-tipo-pretendente" place="right" type="dark" effect="float">
  //         <span>Informe qual a condição do pretendente, se é o inquilino ou o fiador da locação</span>
  //       </ReactTooltip>
  //     </React.Fragment>
  //   )
  // }

  if(label === 'Nome') {
    if (isResumePretendenteForm()) {
      return (
        <ReactTooltip id="tooltip-input-nome" place="right" type="dark" effect="float">
          <span>Não se preocupe em inserir o nome <br />completo, o sistema vai sobrescrever essa informação, apenas <br /> o 1° nome para facilitar sua identificação é o suficiente.</span>
        </ReactTooltip>
      );
    }
    return(
      <React.Fragment>
        <TourTooltip
          target="tooltip-input-nome"
          style={{ left: 33 }}
        />
        <ReactTooltip id="tooltip-input-nome" place="right" type="dark" effect="float">
          <span>Não se preocupe em inserir o nome <br />completo, o sistema vai sobrescrever essa informação, apenas <br /> o 1° nome para facilitar sua identificação é o suficiente.</span>
        </ReactTooltip>
      </React.Fragment>
    )
  }

  // if(label === 'CPF') {
  //   return(
  //     <React.Fragment>
  //       <TourTooltip
  //         target="tooltip-input-cpf"
  //         style={{right: -10}}
  //       />
  //       <ReactTooltip id="tooltip-input-cpf" place="right" type="dark" effect="float">
  //         <span>CPF é a chave de busca para nossa análise</span>
  //       </ReactTooltip>
  //     </React.Fragment>
  //   )
  // }

  if(label === 'PERFIL FINANCEIRO por') {
    if (isResumePretendenteForm()) {
      return (
        <ReactTooltip id="tooltip-input-perfil-financeiro" place="right" type="dark" effect="float">
          <div style={{ height: 'max-content' }}>Você pode preencher com as informações iniciais que possui do seu pretendente, ou mesmo escolher a opção <b>renda não informada</b>. E fique tranquilo, este campo é editável.</div>
        </ReactTooltip>
      );
    }
    return(
      <React.Fragment>
        <TourTooltip
          target="tooltip-input-perfil-financeiro"
          style={withCorner({right: -10})}
        />
        <ReactTooltip id="tooltip-input-perfil-financeiro" place="right" type="dark" effect="float">
          <div style={{height: 'max-content'}}>Você pode preencher com as informações iniciais que possui do seu pretendente, ou mesmo escolher a opção <b>renda não informada</b>. E fique tranquilo, este campo é editável.</div>
        </ReactTooltip>
      </React.Fragment>
    )
  }

  return null
}

const TextInputContainer = ({ htmlFor, children, label, size, type, customStyle }) => {
  const isPretendenteForm = isResumePretendenteForm();
  const showLocacaoLabelRow =
    isResumeLocacaoForm() && LOCACAO_TOOLTIP_LABELS.includes(label);

  const labelRowMarginBottom =
    label !== 'WITHOUT_LABEL' && type !== 'select' ? '6px' : '2px';

  return (
    <StyledTextInputContainer className={`${size}`}>
      <FormGroup style={{ marginBottom: 0, backgroundColor: 'transparent' }} cols="true" className={`${label}`}>
        {showLocacaoLabelRow ? (
          <div
            className="fc-locacao-label-row"
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              alignItems: 'center',
              gap: 6,
              marginBottom: labelRowMarginBottom,
            }}
          >
            {handleLabel(label, htmlFor, type, { marginBottom: 0, flexShrink: 0 })}
            <TourTooltip
              target={LOCACAO_TOOLTIP_TARGETS[label]}
              style={{
                position: 'static',
                top: 'auto',
                right: 'auto',
                zIndex: 4,
                flexShrink: 0,
              }}
            />
          </div>
        ) : label === 'Nome' && isPretendenteForm ? (
          <div
            className="fc-pretendente-nome-label-row"
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              alignItems: 'center',
              gap: 6,
              marginBottom: labelRowMarginBottom,
            }}
          >
            {handleLabel(label, htmlFor, type, { marginBottom: 0, flexShrink: 0 })}
            <TourTooltip
              target="tooltip-input-nome"
              style={{
                position: 'static',
                top: 'auto',
                right: 'auto',
                zIndex: 4,
                flexShrink: 0,
              }}
            />
          </div>
        ) : (
          handleLabel(label, htmlFor, type)
        )}
        {label === 'PERFIL FINANCEIRO por' && isPretendenteForm ? (
          <div
            className="fc-perfil-renda-tooltip-anchor"
            style={{
              position: 'relative',
              display: 'block',
              width: '100%',
              overflow: 'visible',
              zIndex: 2,
            }}
          >
            {children}
            <TourTooltip
              target="tooltip-input-perfil-financeiro"
              style={
                typeof window !== 'undefined' && window.innerWidth <= 1024
                  ? {
                      top: 0,
                      /* Mobile / estreito: acima da faixa azul, sem cobrir a seta do select (IncomeForm) */
                      right: 48,
                      zIndex: 30,
                      transform: 'translateY(calc(-100% - 6px))',
                    }
                  : {
                      /* Web desktop: quina superior direita do campo (igual fluxo não-resumo / withCorner) */
                      top: -10,
                      right: -6,
                      zIndex: 6,
                      transform: 'none',
                    }
              }
            />
          </div>
        ) : (
          children
        )}
      </FormGroup>
      {renderTooltip(label)}
    </StyledTextInputContainer>
  );
};

TextInputContainer.defaultProps = {
  isRequired: false,
  renderCustomInput: () => null,
  customStyle: {}
}

export default TextInputContainer;
